import React, { Component } from 'react';
import { connect } from 'react-redux';

import 'components/tenant_app/tenant_showing.css';

import { ListItem } from 'material-ui/List';
import BookingIcon from '@material-ui/icons/DateRangeTwoTone';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { MdAccessTime as TimeIcon } from 'react-icons/md';

import * as bookings from 'actions/bookingsActions';

import { toFriendlyDateStringNoYear } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

import ShowingSelector from './ShowingSelector';

export default withMobileDialog()(
  connect((store) => {
    return {
      showSelectBooking: store.bookings.select_availability,
      timeAvailability: store.bookings.timeAvailability,
      isLoading: store.bookings.isLoading,
      dialogOpen: store.bookings.dialogOpen,
      bookingError: store.bookings.showBookingError,
      showModifyBookingForm: store.bookings.modifyShowing,
    };
  }, bookings)(
    class TenantShowingDialog extends Component {
      dialogClosed = () => {
        if (!this.props.dialogOpen) {
          return true;
        }
      };

      submitForm = (vars) => {
        this.props.setToIsLoading();
        this.props.removePreviousSearchResults();
        const unitType = this.props.showingData.property.hide_unit_types ? 'all' : vars.unit_type;
        this.props.getApartmentAvailability(
          this.props.showingData.property.property_id,
          vars.time,
          vars.date,
          unitType
        );
      };

      cancel_booking = () => {
        this.props.cancelBooking(this.props.showingData.booking_id);
      };

      render() {
        const data = this.props.showingData;

        const style = {
          table_header: {
            margin: '5px -20px 10px -20px',
            backgroundColor: '#f1f1f1',
            padding: '5px 10px',
            fontSize: '14px',
            fontWeight: '800',
          },
          due_date: {
            color: '#6F6F6F',
            fontSize: '15px',
            textAlign: 'center',
          },
          second_tier: {
            fontSize: '14px',
            color: '#6F6F6F',
          },
        };

        return (
          <div>
            <ListItem
              onClick={this.props.openDialog}
              primaryText={
                <div style={{ marginTop: '-4px' }}>
                  <span style={{ textOverflow: 'ellipsis' }}>
                    Showing at {data.property.property_name}
                  </span>
                  <br />
                  <span style={style.second_tier}>{data.showing_time}</span>
                </div>
              }
              leftIcon={<BookingIcon style={{ color: AccentColor() }} />}
              style={{ fontSize: '15px', color: '#3e3e3e' }}
            />
            <Dialog
              disableBackdropClick
              fullScreen={this.props.fullScreen}
              open={this.props.dialogOpen || false}
              onClose={this.props.closeDialog}
              aria-labelledby="showing-details"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="amenity-booking">
                <h3 style={{ textAlign: 'center', margin: 0 }}>Showing Details</h3>
              </DialogTitle>
              <DialogContent>
                <div className="row" style={style.table_header}>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ textAlign: 'center' }}>Property Details</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12" style={{ padding: '0px 5px', fontSize: '15px' }}>
                    <p style={{ marginBottom: '1px' }}>{data.property.property_street}</p>
                    <p style={{ marginBottom: '1px' }}>{data.property.property_city}</p>
                    <p style={{ marginBottom: '1px' }}>{data.property.property_country}</p>
                  </div>
                </div>

                <div className="row" style={style.table_header}>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ textAlign: 'center' }}>Showing Details</span>
                  </div>
                </div>

                <div className="row" style={{ marginTop: '20px', fontSize: '15px' }}>
                  <div className="col-xs-7" style={{ padding: 0 }}>
                    <p>
                      <span>
                        <TimeIcon size={16} style={{ verticalAlign: 'text-bottom' }} />
                      </span>
                      &nbsp;{toFriendlyDateStringNoYear(data.actionable_date)} at{' '}
                      {data.showing_time}
                    </p>
                  </div>
                  <div className="col-xs-5" style={{ padding: 0 }}>
                    <p style={{ textAlign: 'right', marginRight: '24px' }}>
                      <button type="button" className="link-button" onClick={this.cancel_booking}>
                        Cancel
                      </button>
                    </p>
                  </div>
                </div>

                <div className="row" style={style.table_header}>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ textAlign: 'center' }}>Showing Instructions</span>
                  </div>
                </div>

                <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
                  {data.showing_instructions && (
                    <p style={{ marginBottom: '15px' }}> {data.showing_instructions} </p>
                  )}

                  {!data.showing_instructions && (
                    <p style={{ marginBottom: '15px' }}>
                      {' '}
                      Please show up at least 15 minutes prior to the scheduled showing time.{' '}
                    </p>
                  )}
                </div>
                <ShowingSelector
                  submitForm={this.submitForm}
                  bookingId={this.props.showingData.booking_id}
                  hideUnitTypes={this.props.showingData.property.hide_unit_types}
                />
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton label="Close" primary={true} onClick={this.props.closeDialog} />
              </DialogActions>
            </Dialog>
          </div>
        );
      }
    }
  )
);
